import { json, JsonApi } from "../json";
import { shell } from "../shell";

export interface PkgApi extends JsonApi {
    hasDependency(name: string): Promise<boolean>;
    hasDependencies(names: string[]): Promise<boolean>;
    hasDevDependency(name: string): Promise<boolean>;
    hasDevDependencies(name: string[]): Promise<boolean>;
    runScript(name: string, args?: string[]): Promise<void>;
    getScript(name: string): Promise<string | undefined>;
    hasScript(name: string): Promise<boolean>;
    setScript(name: string, script: string): this;
}

const pkg = (): PkgApi =>
    json.extend<Omit<PkgApi, keyof JsonApi>>((_, jsonApi) => ({
        ...jsonApi,
        hasDependency: name =>
            json("package.json").hasProperty(["dependencies", name]),
        hasDependencies: names =>
            json("package.json").hasProperties(
                names.map(name => ["dependencies", name]),
            ),
        hasDevDependency: name =>
            json("package.json").hasProperty(["devDependencies", name]),
        hasDevDependencies: names =>
            json("package.json").hasProperties(
                names.map(name => ["devDependencies", name]),
            ),
        runScript: async (name, args = []) => {
            args = args.length ? ["--", ...args] : [];
            await shell().exec("npm", ["run", name, ...args]);
        },
        getScript: name => jsonApi.getProperty(["scripts", name]),
        hasScript: name => jsonApi.hasProperty(["scripts", name]),
        setScript: (name, script) =>
            jsonApi.setProperty(["scripts", name], script),
    }))("package.json");

export default pkg;
